import type { CallQualityIssue } from './types';

/**
 * Post-call quality feedback: the choices offered to the guide once a call
 * ends. Pure data (no UI) so both call screens and the form word it once.
 *
 * Mirrors the legacy Uniphone feedback screen — same slugs, same order — so
 * the backend's call-quality reports read both apps alike.
 */

/** Highest star rating; a call rated this well is not asked what went wrong. */
export const MAX_CALL_RATING = 5;

export const CALL_QUALITY_ISSUES: readonly { value: CallQualityIssue; label: string }[] = [
    { value: 'dropped-call', label: 'Call connected but dropped' },
    { value: 'audio-latency', label: 'Call with audio delay' },
    { value: 'one-way-audio', label: 'One way audio' },
    { value: 'choppy-audio', label: 'Call with some words lost' },
    { value: 'noisy-call', label: 'Noisy call' },
    { value: 'echo', label: 'There was echo during the call' },
];

/** Whether a rating is low enough to ask which problem the guide ran into. */
export function shouldAskForIssue(rating: number): boolean {
    return rating >= 1 && rating < MAX_CALL_RATING;
}
